import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
/**
 * 
 * @param { showDialog: {title: string, text: string, isOpen: Boolean, onYes: function, onNo: function}} props 
 * @returns void
 */
export default function AppDialog(props) {

    return (
        <React.Fragment>
            <Dialog
                open={props.showDialog.isOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
            <DialogTitle id="alert-dialog">{props.showDialog.title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {props.showDialog.text}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button  
                    color="primary"
                    onClick={(e) => {
                        if (props.hasOwnProperty("showDialog") && props.showDialog.hasOwnProperty("onNo")) {
                            props.showDialog.onNo.call();
                        }
                       
                    }}
                >
                    No
                </Button>
                <Button
                    onClick={(e) => {
                        if (props.hasOwnProperty("showDialog") && props.showDialog.hasOwnProperty("onYes")) {
                            props.showDialog.onYes.call();
                        } 
                    }}
                    color="primary"
                >
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
    </React.Fragment>
    );
}

AppDialog.propTypes = {
    showDialog: PropTypes.object,
}

